export default __webpack_public_path__ + "static/media/Dr_Neeru_Bhooshan_latest.7547c431.jpg";